import {
    DELETE_USER_WEIGHT,
    DELETE_USER_WEIGHT_FAIL,
    DELETE_USER_WEIGHT_FETCHING,
    DELETE_USER_WEIGHT_SUCCESS,
    FETCH_52_WEEKS_WEIGHTS,
    FETCH_52_WEEKS_WEIGHTS_FAIL,
    FETCH_52_WEEKS_WEIGHTS_FETCHING,
    FETCH_52_WEEKS_WEIGHTS_SUCCESS,
    FETCH_DAY_WEIGHTS,
    FETCH_DAY_WEIGHTS_FAIL,
    FETCH_DAY_WEIGHTS_SUCCESS,
    FETCH_MONTHLY_WEIGHTS,
    FETCH_MONTHLY_WEIGHTS_FAIL,
    FETCH_MONTHLY_WEIGHTS_FETCHING,
    FETCH_MONTHLY_WEIGHTS_SUCCESS,
    FETCH_MULTIPLE_DAYS_WEIGHTS,
    FETCH_MULTIPLE_DAYS_WEIGHTS_FAIL,
    FETCH_MULTIPLE_DAYS_WEIGHTS_FETCHING,
    FETCH_MULTIPLE_DAYS_WEIGHTS_SUCCESS,
    SET_CURRENT_WEIGHT_TAB,
    FETCH_MULTIPLE_DAILY_WEIGHTS,
    FETCH_MULTIPLE_DAILY_WEIGHTS_FETCHING,
    FETCH_MULTIPLE_DAILY_WEIGHTS_SUCCESS,
    FETCH_MULTIPLE_DAILY_WEIGHTS_FAIL,
    FETCH_52_WEEKS_WEIGHTS_REPORT,
    FETCH_52_WEEKS_WEIGHTS_REPORT_FETCHING,
    FETCH_52_WEEKS_WEIGHTS_REPORT_SUCCESS,
    FETCH_52_WEEKS_WEIGHTS_REPORT_FAIL,
    FETCH_WEIGHT_GAIN_GOALS,
    FETCH_WEIGHT_GAIN_GOALS_FETCHING,
    FETCH_WEIGHT_GAIN_GOALS_SUCCESS,
    FETCH_WEIGHT_GAIN_GOALS_FAIL
} from 'actions/weightActions';
import { calculateBMI, MULTIPLE_DAYS_REQUEST_KEYS, TABS } from 'Weight/WeightUtils';
import { FETCH_USER_SETTINGS_SUCCESS } from 'actions/ActionTypes';

const INITIAL_STATE = {
    weights: {},
    monthlyWeights: {
        isFetching: null,
        didFetchFail: false
    },
    oneMonthWeights: {
        isFetching: null,
        didFetchFail: false
    },
    sevenDaysWeights: {
        isFetching: null,
        didFetchFail: false
    },
    fourWeeksWeights: {
        isFetching: null,
        didFetchFail: false
    },
    fiftyTwoWeeksWeights: {
        isFetching: null,
        didFetchFail: false
    },
    fiftyTwoWeeksWeightsReport: {
        isFetching: null,
        didFetchFail: false
    },
    // We need this to calculate BMI...
    userSettings: null,
    isFetching: null,
    didFetchFail: false,
    currentTab: TABS.ONE_DAY,
    deletedUserWeight: null,
    deletedUserWeightFetching: null,
    dailyWeights: {
        weights: null,
        isFetching: false,
        error: false,
        success: false
    },
    weightGainGoals: {
        userGoalRanges: null,
        userGoals: null,
        isFetching: false,
        error: false,
        success: false
    }
};

// ======= Fetching Handlers =======
const fetchDayWeightsFetching = (state) => {
    return {
        ...state,
        weights: { ...state.weights },
        isFetching: true,
        didFetchFail: false
    };
};

const fetchDayWeightsSuccess = (state, action) => {
    if (action.data && action.data.dateWeightList) {
        action.data.dateWeightList.forEach((weight) => {
            addBMI(weight, state.userSettings);
        });
    }
    return {
        ...state,
        weights: { ...state.weights, [action.date]: action.data },
        isFetching: false,
        didFetchFail: false
    };
};

const fetchDayWeightFail = (state, action) => {
    delete state.dayWeightList.weights[action.date];
    return {
        ...state,
        weights: { ...state.weights },
        isFetching: false,
        didFetchFail: true
    };
};

const setCurrentWeightTabState = (state, action) => {
    return {
        ...state,
        currentTab: action.currentTab
    };
};

const fetchMonthlyWeightFetching = (state) => {
    return {
        ...state,
        monthlyWeights: {
            ...state.monthlyWeights,
            isFetching: true,
            didFetchFail: false
        }
    };
};

const fetch52WeeksWeightFetching = (state) => {
    return {
        ...state,
        fiftyTwoWeeksWeights: {
            ...state.fiftyTwoWeeksWeights,
            isFetching: true,
            didFetchFail: false
        }
    };
};

const fetch52WeeksWeightReportFetching = (state) => {
    return {
        ...state,
        fiftyTwoWeeksWeightsReport: {
            ...state.fiftyTwoWeeksWeightsReport,
            isFetching: true,
            didFetchFail: false
        }
    };
};

const fetchMultipleDaysWeightsFetching = (state, action) => {
    let keyProp = action.dateRange ? action.dateRange : MULTIPLE_DAYS_REQUEST_KEYS.SEVEN_DAYS;
    return {
        ...state,
        [keyProp]: {
            ...state[keyProp],
            isFetching: true,
            didFetchFail: false
        }
    };
};

const fetch52WeeksWeightSuccess = (state, action) => {
    if (action.data) {
        if (action.data.weeklyWeightSummaries) {
            action.data.weeklyWeightSummaries.forEach((weight) => {
                const weightData = weight.averageWeight;
                addBMI(weightData, state.userSettings);
            });
        }
        if (action.data.previousWeekAverageDTO) {
            let prevWeight = action.data.previousWeekAverageDTO;
            addBMI(prevWeight, state.userSettings);
        }

        if (action.data.nextWeekAverageDTO) {
            let nextWeight = action.data.nextWeekAverageDTO;
            addBMI(nextWeight, state.userSettings);
        }
    }
    return {
        ...state,
        fiftyTwoWeeksWeights: {
            ...state.fiftyTwoWeeksWeights,
            [action.endDate]: action.data,
            isFetching: false,
            didFetchFail: false
        }
    };
};

const addBMIMultipleWeightsPerDay = (data, state) => {
    if (data.dailyWeightSummaries) {
        data.dailyWeightSummaries.forEach((weight) => {
            const weightData = weight.latestWeight;
            addBMI(weightData, state.userSettings);
            if (weight.allWeightMetrics && weight.allWeightMetrics.length) {
                weight.allWeightMetrics.forEach((item) => {
                    addBMI(item, state.userSettings);
                });
            }
        });
    }
};

const fetch52WeeksWeightReportSuccess = (state, action) => {
    if (action.data && action.data.dailyWeightSummaries) {
        addBMIMultipleWeightsPerDay(action.data, state);
    }
    return {
        ...state,
        fiftyTwoWeeksWeightsReport: {
            ...state.fiftyTwoWeeksWeightsReport,
            [action.endDate]: action.data,
            isFetching: false,
            didFetchFail: false
        }
    };
};

const fetchMonthlyWeightSuccess = (state, action) => {
    if (action.data) {
        if (action.data.monthlyWeightSummarys) {
            action.data.monthlyWeightSummarys.forEach((weight) => {
                const weightData = weight.averageWeight;
                addBMI(weightData, state.userSettings);
            });
        }
        if (action.data.previousMonthAverageDTO) {
            let prevWeight = action.data.previousMonthAverageDTO;
            addBMI(prevWeight, state.userSettings);
        }

        if (action.data.nextMonthAverageDTO) {
            let nextWeight = action.data.nextMonthAverageDTO;
            addBMI(nextWeight, state.userSettings);
        }
    }
    return {
        ...state,
        monthlyWeights: {
            ...state.monthlyWeights,
            [action.endDate]: action.data,
            isFetching: false,
            didFetchFail: false
        }
    };
};

const fetchMultipleDaysWeightsSuccess = (state, action) => {
    if (action.data) {
        addBMIMultipleWeightsPerDay(action.data, state);

        if (action.data.previousDateWeight) {
            let prevWeight = action.data.previousDateWeight;
            addBMI(prevWeight, state.userSettings);
        }

        if (action.data.nextDateWeight) {
            let nextWeight = action.data.nextDateWeight;
            addBMI(nextWeight, state.userSettings);
        }
    }
    let keyProp = action.dateRange ? action.dateRange : MULTIPLE_DAYS_REQUEST_KEYS.SEVEN_DAYS;
    return {
        ...state,
        [keyProp]: {
            ...state[keyProp],
            [action.endDate]: action.data,
            isFetching: false,
            didFetchFail: false
        }
    };
};

const fetchMonthlyWeightFail = (state) => {
    return {
        ...state,
        monthlyWeights: {
            ...state.monthlyWeights,
            isFetching: false,
            didFetchFail: true
        }
    };
};

const fetch52WeeksWeightFail = (state) => {
    return {
        ...state,
        fiftyTwoWeeksWeights: {
            ...state.fiftyTwoWeeksWeights,
            isFetching: false,
            didFetchFail: true
        }
    };
};
const fetch52WeeksWeightReportFail = (state) => {
    return {
        ...state,
        fiftyTwoWeeksWeightsReport: {
            ...state.fiftyTwoWeeksWeightsReport,
            isFetching: false,
            didFetchFail: true
        }
    };
};

const fetchMultipleDaysWeightsFail = (state, action) => {
    let keyProp = action.dateRange ? action.dateRange : MULTIPLE_DAYS_REQUEST_KEYS.SEVEN_DAYS;
    return {
        ...state,
        [keyProp]: {
            ...state[keyProp],
            isFetching: false,
            didFetchFail: true
        }
    };
};

const afterDeleteUserWeight = (success) => (state, action) => {
    if (action.reloadPage) {
        window.location.reload();
    }
    return {
        ...state,
        deletedUserWeight: success,
        deletedUserWeightFetching: false
    };
};
const deleteUserWeightFetching = (state) => {
    return {
        ...state,
        deletedUserWeightFetching: true
    };
};

// We need this to calculate BMI...
const userSettingsFetchFinished = (state, action) => {
    return {
        ...state,
        userSettings: action.userSettings
    };
};

const fetchMultipleDailyWeight = (state) => {
    return {
        ...state,
        dailyWeights: {
            ...state.dailyWeights,
            isFetching: true
        }
    };
};

const multipleDailyWeightSuccess = (success) => (state, action) => {
    return {
        ...state,
        dailyWeights: {
            ...state.dailyWeights,
            weights: success ? action.data : null,
            isFetching: false,
            success: success,
            error: !success
        }
    };
};

const weightGainGoalsFetched = (success) => (state, action) => {
    return {
        ...state,
        weightGainGoals: {
            ...state.weightGainGoals,
            userGoalRanges: success ? action.data.userGoalRanges : null,
            userGoals: success ? action.data.userGoals : null,
            isFetching: false,
            success: success,
            error: !success
        }
    };
};

const weightGainGoalsFetching = (state) => {
    return {
        ...state,
        weightGainGoals: {
            ...state.weightGainGoals,
            isFetching: true
        }
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_DAY_WEIGHTS]: fetchDayWeightsFetching,
    [FETCH_DAY_WEIGHTS_SUCCESS]: fetchDayWeightsSuccess,
    [FETCH_DAY_WEIGHTS_FAIL]: fetchDayWeightFail,
    [SET_CURRENT_WEIGHT_TAB]: setCurrentWeightTabState,
    [FETCH_MONTHLY_WEIGHTS_FETCHING]: fetchMonthlyWeightFetching,
    [FETCH_MONTHLY_WEIGHTS_SUCCESS]: fetchMonthlyWeightSuccess,
    [FETCH_MONTHLY_WEIGHTS_FAIL]: fetchMonthlyWeightFail,
    [FETCH_52_WEEKS_WEIGHTS_FETCHING]: fetch52WeeksWeightFetching,
    [FETCH_52_WEEKS_WEIGHTS_SUCCESS]: fetch52WeeksWeightSuccess,
    [FETCH_52_WEEKS_WEIGHTS_FAIL]: fetch52WeeksWeightFail,
    [FETCH_52_WEEKS_WEIGHTS_REPORT_FETCHING]: fetch52WeeksWeightReportFetching,
    [FETCH_52_WEEKS_WEIGHTS_REPORT_SUCCESS]: fetch52WeeksWeightReportSuccess,
    [FETCH_52_WEEKS_WEIGHTS_REPORT_FAIL]: fetch52WeeksWeightReportFail,
    [FETCH_MULTIPLE_DAYS_WEIGHTS_FETCHING]: fetchMultipleDaysWeightsFetching,
    [FETCH_MULTIPLE_DAYS_WEIGHTS_SUCCESS]: fetchMultipleDaysWeightsSuccess,
    [FETCH_MULTIPLE_DAYS_WEIGHTS_FAIL]: fetchMultipleDaysWeightsFail,
    [DELETE_USER_WEIGHT_FETCHING]: deleteUserWeightFetching,
    [DELETE_USER_WEIGHT_SUCCESS]: afterDeleteUserWeight(true),
    [DELETE_USER_WEIGHT_FAIL]: afterDeleteUserWeight(false),
    // We need this to calculate BMI...
    [FETCH_USER_SETTINGS_SUCCESS]: userSettingsFetchFinished,
    [FETCH_MULTIPLE_DAILY_WEIGHTS_FETCHING]: fetchMultipleDailyWeight,
    [FETCH_MULTIPLE_DAILY_WEIGHTS_SUCCESS]: multipleDailyWeightSuccess(true),
    [FETCH_MULTIPLE_DAILY_WEIGHTS_FAIL]: multipleDailyWeightSuccess(false),
    [FETCH_WEIGHT_GAIN_GOALS_FETCHING]: weightGainGoalsFetching,
    [FETCH_WEIGHT_GAIN_GOALS_SUCCESS]: weightGainGoalsFetched(true),
    [FETCH_WEIGHT_GAIN_GOALS_FAIL]: weightGainGoalsFetched(false)
};

// ======= Default Action =======
export default function dayWeightList(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchDayWeights(date) {
    return {
        type: FETCH_DAY_WEIGHTS,
        date: date
    };
}

export function setCurrentWeightTab(currentTab) {
    return {
        type: SET_CURRENT_WEIGHT_TAB,
        currentTab: currentTab
    };
}

export function fetchMonthlyWeight(dates, evictCache) {
    return {
        type: FETCH_MONTHLY_WEIGHTS,
        dates,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function fetch52WeeksWeightData(dates, evictCache) {
    return {
        type: FETCH_52_WEEKS_WEIGHTS,
        dates,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function fetch52WeeksWeightReportData(dates, evictCache) {
    return {
        type: FETCH_52_WEEKS_WEIGHTS_REPORT,
        dates,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function fetchMultipleDaysWeights(dates, dateRange, evictCache) {
    return {
        type: FETCH_MULTIPLE_DAYS_WEIGHTS,
        dates,
        dateRange: dateRange,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function deleteUserWeight(weightId, date, actionToDispatch, reloadPage) {
    return {
        type: DELETE_USER_WEIGHT,
        weightId: weightId,
        date: date,
        actionToDispatch,
        reloadPage
    };
}

export const fetchMultipleDailyWeights = (startDate, endDate, callback) => {
    return {
        type: FETCH_MULTIPLE_DAILY_WEIGHTS,
        dates: {
            startDate,
            endDate
        },
        callback: callback
    };
};

export const fetchWeightGainGoals = (startDate, endDate) => {
    return {
        type: FETCH_WEIGHT_GAIN_GOALS,
        dates: {
            startDate,
            endDate
        }
    };
};

// ======= Selectors =======
export const getDayWeights = (state, date) => {
    return state.dayWeightList.weights[date];
};

export const getCurrentTab = (state) => {
    return state.dayWeightList.currentTab;
};

export const getMonthlyWeightSummaries = (state, date) => {
    return state.dayWeightList.monthlyWeights[date]
        ? state.dayWeightList.monthlyWeights[date].monthlyWeightSummarys
        : null;
};

export const get52WeeksWeightSummaries = (state, date) => {
    return state.dayWeightList.fiftyTwoWeeksWeights[date]
        ? state.dayWeightList.fiftyTwoWeeksWeights[date].weeklyWeightSummaries
        : null;
};

export const get52WeeksWeightSummariesReportData = (state, date) => {
    return state.dayWeightList.fiftyTwoWeeksWeightsReport[date]
        ? state.dayWeightList.fiftyTwoWeeksWeightsReport[date].dailyWeightSummaries
        : null;
};

export const getDailyWeightSummaries = (state, date) => {
    return state.dayWeightList.sevenDaysWeights[date]
        ? state.dayWeightList.sevenDaysWeights[date].dailyWeightSummaries
        : null;
};

export const getDailyWeightSummariesPrevWeight = (state, date) => {
    return state.dayWeightList.sevenDaysWeights[date]
        ? state.dayWeightList.sevenDaysWeights[date].previousDateWeight
        : null;
};

export const getDailyWeightSummariesNextWeight = (state, date) => {
    return state.dayWeightList.sevenDaysWeights[date]
        ? state.dayWeightList.sevenDaysWeights[date].nextDateWeight
        : null;
};

export const isDailyWeightSummariesFetching = (state) => {
    return state.dayWeightList.sevenDaysWeights.isFetching;
};

export const isDayWeightEntriesFetching = (state) => {
    return state.dayWeightList.isFetching;
};

export const isMonthlyWeightFetching = (state) => {
    return state.dayWeightList.monthlyWeights.isFetching;
};

export const is52WeeksWeightFetching = (state) => {
    return state.dayWeightList.fiftyTwoWeeksWeights.isFetching;
};

export const isFourWeeksWeightFetching = (state) => {
    return state.dayWeightList.fourWeeksWeights.isFetching;
};

export const getFourWeeksWeightSummaries = (state, date) => {
    return state.dayWeightList.fourWeeksWeights[date]
        ? state.dayWeightList.fourWeeksWeights[date].dailyWeightSummaries
        : null;
};

export const getFourWeeksWeightSummariesPrevWeight = (state, date) => {
    return state.dayWeightList.fourWeeksWeights[date]
        ? state.dayWeightList.fourWeeksWeights[date].previousDateWeight
        : null;
};

export const getFourWeeksWeightSummariesNextWeight = (state, date) => {
    return state.dayWeightList.fourWeeksWeights[date]
        ? state.dayWeightList.fourWeeksWeights[date].nextDateWeight
        : null;
};

export const isOneMonthFetching = (state) => {
    return state.dayWeightList.oneMonthWeights.isFetching;
};

export const geOneMonthWeightSummaries = (state, date) => {
    return state.dayWeightList.oneMonthWeights[date]
        ? state.dayWeightList.oneMonthWeights[date].dailyWeightSummaries
        : null;
};

export const geOneMonthWeightSummariesPrevWeight = (state, date) => {
    return state.dayWeightList.oneMonthWeights[date]
        ? state.dayWeightList.oneMonthWeights[date].previousDateWeight
        : null;
};

export const geOneMonthWeightSummariesNextWeight = (state, date) => {
    return state.dayWeightList.oneMonthWeights[date] ? state.dayWeightList.oneMonthWeights[date].nextDateWeight : null;
};

export const getTwelveMonthsWeightSummariesPrevWeight = (state, date) => {
    return state.dayWeightList.monthlyWeights[date]
        ? state.dayWeightList.monthlyWeights[date].previousMonthAverageDTO
        : null;
};

export const getTwelveMonthsWeightSummariesNextWeight = (state, date) => {
    return state.dayWeightList.monthlyWeights[date]
        ? state.dayWeightList.monthlyWeights[date].nextMonthAverageDTO
        : null;
};

export const get52WeeksWeightSummariesPrevWeight = (state, date) => {
    return state.dayWeightList.fiftyTwoWeeksWeights[date]
        ? state.dayWeightList.fiftyTwoWeeksWeights[date].previousWeekAverageDTO
        : null;
};

export const get52WeeksWeightSummariesNextWeight = (state, date) => {
    return state.dayWeightList.fiftyTwoWeeksWeights[date]
        ? state.dayWeightList.fiftyTwoWeeksWeights[date].nextWeekAverageDTO
        : null;
};

export const addBMI = (weightObj, userSettings) => {
    if (weightObj) {
        if (!weightObj.bmi && weightObj.sourceType !== 'INDEX_SCALE') {
            weightObj.bmi = calculateBMI(weightObj.weight, userSettings);
        }
    }
};

export const isDailyWeightsFetchSuccess = (state) => {
    return state.dayWeightList.dailyWeights.success;
};

export const getDailyWeights = (state) => {
    return state.dayWeightList.dailyWeights.weights;
};

export const isWeightGainGoalsFetching = (state) => {
    return state.dayWeightList.weightGainGoals.isFetching;
};

export const isWeightGainGoalsSuccess = (state) => {
    return state.dayWeightList.weightGainGoals.success;
};

export const isWeightGainGoalsError = (state) => {
    return !state.dayWeightList.weightGainGoals.success;
};

export const weightGainGoals = (state) => {
    return state.dayWeightList.weightGainGoals.userGoalRanges;
};
